import { Checkbox, Tooltip } from '@mui/material'
import {
    Modal,
    ModalBody,
    ModalContent,
    useDisclosure,
} from '@nextui-org/react'
import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import LazyLoad from 'react-lazy-load'
import config from '../../config.json'

import AssetPreviewDisplay from '../assetpreviewdisplay/AssetPreviewDisplay'
import BackedInfo from '../backedinfo/BackedInfo'
import { MarketCard } from '../card/MarketCard'
import Link2 from '../common/util/input/Link2'
import MarketButtons from '../marketbuttons/MarketButtons'
import { MintInfo } from '../mintinfo/MintInfo'
import RankInfo from '../rankinfo/RankInfo'
import { useSharedState } from '../waxplorer/Waxplorer'
import { AssetDetailsPopupContent } from './AssetDetailsPopupContent'
import { CollectionAssetName } from './CollectionAssetName'
import { MarketAssetPreviewInfo } from './MarketAssetPreviewInfo'
import MoreOptions from './MoreOptions'
import { TimeSinceListed } from './TimeSinceListed'
import { useTheme } from 'next-themes'
import { ModalActions } from './ModalActions'
import { useToast } from '../ui/use-toast'
import { showErrorToast, showSuccessToast } from '../../utils/toasts'

// @ts-ignore
const MarketAssetPreview = ({
    listing,
    selectedAsset,
    onAdd,
    bundleView,
    page,
    showOwner,
    selectable,
    searchOwner,
    clickAsset,
    index,
    assetType,
    previewDuration = 2,
    handleCheck,
    selectedAssets,
    transferredAssets = {},
    errorAssets,
}) => {
    const [state, dispatch] = useSharedState()
    const { theme } = useTheme()
    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null
    const [currentAsset, setCurrentAsset] = useState(0)
    const [newOwner, setNewOwner] = useState(null)
    const [showMenu, setShowMenu] = useState(false)
    const [bought, setBought] = useState(false)
    const [canceled, setCanceled] = useState(false)
    const [sold, setSold] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [transferred, setTransferred] = useState(false)
    const [action, setAction] = useState(null)

    const { assets, listingId, market } = listing

    const asset = assets[currentAsset]

    let {
        assetId,
        collection,
        image,
        mint,
        rank,
        rarityScore,
        backedTokens,
        mutableData,
        name,
        template,
    } = asset

    useEffect(() => {
        if (Object.keys(transferredAssets).length > 0) {
            for (let localId of Object.keys(transferredAssets)) {
                if (assetId.toString() === localId.toString()) {
                    setNewOwner(transferredAssets[localId]['newOwner'])
                    asset['owner'] = transferredAssets[localId]['newOwner']
                    asset['newOwner'] = transferredAssets[localId]['newOwner']
                    asset['sender'] = userName

                    if (transferredAssets[localId]['sold']) {
                        setSold(true)
                        setNewOwner(transferredAssets[localId]['owner'])
                        asset['price'] = transferredAssets[localId]['price']
                        asset['market'] = transferredAssets[localId]['market']
                    } else if (transferredAssets[localId]['bought']) {
                        setBought(true)
                        asset['price'] = null
                    } else if (transferredAssets[localId]['transferred']) {
                        setTransferred(true)
                    } else if (transferredAssets[localId]['transferred']) {
                        setCanceled(true)
                    }
                }
            }
        }
    }, [
        selectedAssets && selectedAssets.length,
        errorAssets && Object.keys(errorAssets).length,
        transferredAssets && Object.keys(transferredAssets).length,
    ])

    useEffect(() => {
        if (page === 'live') {
            setIsLoading(false)
            setBought(false)
        }
    }, [page, assetId])

    const prevAsset = async () => {
        if (currentAsset > 0) setCurrentAsset(currentAsset - 1)
        else setCurrentAsset(assets.length - 1)
    }

    const nextAsset = async () => {
        if (currentAsset === assets.length - 1) setCurrentAsset(0)
        else setCurrentAsset(currentAsset + 1)
    }

    const assetData = mutableData

    let video = ''

    if (
        assetData &&
        Object.keys(assetData).includes('video') &&
        assetData['video']
    ) {
        video = assetData['video'].includes('http')
            ? assetData['video']
            : `${config.ipfs}${assetData['video']}`
    } else if (image && image.includes('video:')) {
        video = image.replace('video:', '')
        video = video.includes('http') ? video : `${config.ipfs}${video}`
    }

    const toggleShowMenu = () => {
        setShowMenu(!showMenu)
    }

    const assetIncluded = () => {
        return selectedAssets
            .map(
                (a) =>
                    Object.assign(
                        {},
                        a,
                        a.assets?.length > 0 ? a.assets[0] : null,
                    ).assetId,
            )
            .includes(
                (asset.assets?.length > 0 ? asset.assets[0] : asset).assetId,
            )
    }

    const checked = assetIncluded()

    /* check box and share  */
    const cardHeader = (
        <div className={'absolute w-full h-8 z-10'}>
            <div className={'absolute flex m-auto h-10 w-8'}>
                {selectable && selectable(asset) && (
                    <Checkbox
                        checked={checked}
                        onChange={(e) => handleCheck(e, asset)}
                        className=" text-primary"
                    />
                )}
            </div>
            <div />
            <div />
            {page !== 'newbuyoffer' && page !== 'editor' && (
                <MoreOptions
                    setShowMenu={setShowMenu}
                    newOwner={newOwner}
                    showMenu={showMenu}
                    asset={asset}
                    sold={sold}
                    setSold={setSold}
                    setIsLoading={setIsLoading}
                    transferred={transferred}
                    toggleShowMenu={toggleShowMenu}
                    setAction={setAction}
                />
            )}
        </div>
    )

    const href = '/listing/' + market + '/' + (listingId ? listingId : assetId)

    const { isOpen, onOpen, onOpenChange } = useDisclosure()

    const handleCallBack = (info, action) => {
        if (info) {
            if (info['success']) {
                if (action === 'buy') {
                    setNewOwner(userName)
                    asset['owner'] = newOwner
                    asset['price'] = null
                    setBought(true)
                } else if (action === 'sell') {
                    const soldAssets = info['listings']

                    if (soldAssets) {
                        if (soldAssets) {
                            const transferredItems = {}
                            for (const soldAsset of soldAssets) {
                                const localId = soldAsset['assetId']
                                transferredItems[localId] = soldAsset
                                transferredItems[localId]['listings'] = [
                                    {
                                        market: soldAsset['market'],
                                        listingId: soldAsset['listingId'],
                                        price: soldAsset['price'],
                                        quantity: soldAsset['quantity'],
                                        currency: soldAsset['currency'],
                                        seller: userName,
                                    },
                                ]

                                if (localId.toString() === assetId.toString()) {
                                    asset['listings'] = [soldAsset]
                                }
                            }

                            dispatch({
                                type: 'SET_TRANSFERRED_ASSETS',
                                payload: transferredItems,
                            })
                        }
                        setCanceled(false)
                    }

                    setSold(true)
                } else if (action === 'cancel') {
                    setCanceled(true)
                    setSold(false)
                } else if (action === 'edit') {
                    if (info['canceled']) {
                        setCanceled(true)
                        setSold(false)
                    } else if (info['edited']) {
                        const newListing = info['listing']
                        listing['price'] = newListing['price']
                        listing['currency'] = newListing['currency']
                        listing['listingId'] = newListing['listingId']
                    }
                }

                if (
                    [
                        'claim',
                        'sell',
                        'transfer',
                        'unpack',
                        'swap',
                        'stake',
                        'unstake',
                        'break_asset',
                    ].includes(action)
                ) {
                    setTransferred(true)
                }
            }
        }
        setAction(null)
        setIsLoading(false)
    }

    const { toast } = useToast()

    const callBack = (info, localAction = null) => {
        if (info?.success) {
            if (info?.transactionId) {
                showSuccessToast(
                    toast,
                    <Link2
                        external={true}
                        href={
                            'https://waxblock.io/transaction/' +
                            info.transactionId
                        }
                    >
                        <div className={'text-xs font-medium'}>
                            {info.transactionId.substr(0, 32) + '...'}
                        </div>
                    </Link2>,
                )
            }
        }
        if (info?.error) {
            showErrorToast(toast, info.error)
        }

        handleCallBack(info, localAction ? localAction : action)

        setAction(null)
    }

    const marketButtons = (view) => (
        <MarketButtons
            view={view}
            className={
                view === 'full'
                    ? 'mt-auto h-full w-full'
                    : 'mt-auto h-32 w-full'
            }
            onAdd={onAdd}
            listing={listing}
            newOwner={newOwner}
            searchOwner={searchOwner}
            callBack={callBack}
            assetType={assetType}
            page={page}
            bought={bought}
            canceled={canceled}
            sold={sold}
            setSold={setSold}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            showOwner={showOwner}
            currentAsset={currentAsset}
            setAction={setAction}
            action={action}
            onOpen={onOpen}
        />
    )

    return (
        <LazyLoad offset={200}>
            <div>
                <MarketCard
                    height={'normal'}
                    cardHeader={cardHeader}
                    page={page}
                    new={asset['new']}
                >
                    <ModalActions
                        action={action}
                        asset={asset}
                        listing={listing}
                        callBack={callBack}
                    />
                    <div
                        className={
                            ' relative flex  justify-center items-center  !aspect-1 '
                        }
                    >
                        <div
                            className={cn(
                                'flex justify-center items-center w-full h-full',
                            )}
                        >
                            <Link2
                                inactive={
                                    page === 'newbuyoffer' ||
                                    page === 'editor' ||
                                    clickAsset
                                }
                                href={href}
                                onClick={(e) => {
                                    const elem = window.document.getElementById(
                                        'AssetDetailsPopupContent' +
                                            (assetId
                                                ? assetId
                                                : template?.templateId),
                                    )
                                    if (!elem || !elem.contains(e.target)) {
                                        dispatch({
                                            type: 'SET_ACTION_SEARCH',
                                            payload: {
                                                actionSearch: '',
                                                asset: null,
                                                searchType: '',
                                                searchID: '',
                                                includeDrops: false,
                                            },
                                        })
                                    }
                                }}
                                altOnClick={
                                    clickAsset
                                        ? () => clickAsset(index)
                                        : () => {}
                                }
                                className={cn('h-full w-full ')}
                            >
                                <div
                                    className={cn(
                                        'text-center cursor-pointer h-full w-full',
                                    )}
                                >
                                    <Tooltip
                                        leaveDelay={100}
                                        title={
                                            <AssetDetailsPopupContent
                                                asset={asset}
                                                listing={listing}
                                                userName={userName}
                                            />
                                        }
                                        placement="right"
                                        arrow
                                        enterDelay={700}
                                        enterNextDelay={700}
                                        disableTouchListener
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    borderRadius: '1rem',
                                                    backgroundColor:
                                                        theme === 'light'
                                                            ? 'white'
                                                            : '#141414FA',
                                                    maxWidth: 'none',
                                                },
                                            },
                                        }}
                                    >
                                        <div className="w-full h-full overflow-hidden">
                                            <AssetPreviewDisplay
                                                asset={assets[currentAsset]}
                                                image={image}
                                                video={video}
                                                previewDuration={
                                                    previewDuration
                                                }
                                                className={cn('h-full')}
                                                imgClassName={cn(
                                                    'object-contain transition transform h-full w-full',
                                                    'duration-500 md:hover:scale-100 hover:scale-105  cursor-pointer',
                                                )}
                                            />
                                        </div>
                                    </Tooltip>
                                </div>
                            </Link2>

                            {assets.length > 1 ? (
                                <button
                                    className={cn(
                                        'absolute m-auto h-full border-0 text-primary cursor-pointer',
                                        'outline-none text-2xl left-0 opacity-80 hover:opacity-100 w-5 h-5',
                                    )}
                                    onClick={prevAsset}
                                >
                                    ‹
                                </button>
                            ) : null}
                            {assets.length > 1 && (
                                <button
                                    className={cn(
                                        'absolute m-auto h-full border-0 text-primary cursor-pointer',
                                        'outline-none text-2xl right-0 opacity-80 hover:opacity-100 w-5 h-5',
                                    )}
                                    onClick={nextAsset}
                                >
                                    ›
                                </button>
                            )}
                        </div>
                        {mint && !rank && !rarityScore ? (
                            <MintInfo top={'-bottom-4 right-1'} mint={mint} />
                        ) : (
                            ''
                        )}
                        {rank && rarityScore ? (
                            <RankInfo rank={rank} rarityScore={rarityScore} />
                        ) : (
                            ''
                        )}
                        {backedTokens && (
                            <BackedInfo backedTokens={backedTokens} />
                        )}
                    </div>
                    <div
                        className={'p-4 flex flex-wrap h-full justify-between'}
                    >
                        <CollectionAssetName
                            linkInactive={
                                page === 'newbuyoffer' ||
                                page === 'editor' ||
                                clickAsset
                            }
                            onClick={() => {
                                dispatch({
                                    type: 'SET_ACTION_SEARCH',
                                    payload: {
                                        actionSearch: '',
                                        asset: null,
                                        searchType: '',
                                        searchID: '',
                                        includeDrops: false,
                                    },
                                })
                            }}
                            altOnClick={
                                clickAsset ? () => clickAsset(index) : () => {}
                            }
                            href={href}
                            collection={collection}
                            name={name}
                        />

                        {!selectedAsset &&
                            selectedAsset !== 0 &&
                            marketButtons('')}

                        {page === 'live' && <TimeSinceListed asset={asset} />}
                    </div>
                </MarketCard>

                <Modal
                    size={'5xl'}
                    isOpen={isOpen}
                    onOpenChange={onOpenChange}
                    scrollBehavior={'inside'}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    classNames={{
                        body: 'p-0',
                        closeButton:
                            'absolute top-2 right-2 z-50 bg-red-500 text-white hover:bg-red-600',
                    }}
                >
                    <ModalContent>
                        <ModalBody className="w-full px-0 py-0 ">
                            <MarketAssetPreviewInfo
                                asset={asset}
                                listing={listing}
                                newOwner={newOwner}
                                currentAsset={currentAsset}
                                bundleView={bundleView}
                                show={onOpen}
                                buttons={<div>{marketButtons('full')}</div>}
                            />
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </div>
        </LazyLoad>
    )
}

function assetPropsAreEqual(prevAsset, nextAsset) {
    let item1 = 0
    let item2 = 0

    const id1 = (
        prevAsset.listing.assets?.length > 0
            ? prevAsset.listing.assets[0]
            : prevAsset.listing
    ).assetId

    if (
        prevAsset.selectedAssets &&
        prevAsset.selectedAssets
            .map((a) => (a.assets?.length > 0 ? a.assets[0] : a).assetId)
            .includes(id1)
    ) {
        item1 = id1
    }

    const id2 = (
        nextAsset.listing.assets?.length > 0
            ? nextAsset.listing.assets[0]
            : nextAsset.listing
    ).assetId

    if (
        nextAsset.selectedAssets &&
        nextAsset.selectedAssets
            .map((a) => (a.assets?.length > 0 ? a.assets[0] : a).assetId)
            .includes(id2)
    ) {
        item2 = id2
    }

    return (
        ((!prevAsset.selectedAssets && !nextAsset.selectedAssets) ||
            (prevAsset.selectedAssets &&
                nextAsset.selectedAssets &&
                prevAsset.selectedAssets.length ===
                    nextAsset.selectedAssets.length)) &&
        ((!prevAsset.transferredAssets && !nextAsset.transferredAssets) ||
            (prevAsset.transferredAssets &&
                nextAsset.transferredAssets &&
                prevAsset.transferredAssets.length ===
                    nextAsset.transferredAssets.length)) &&
        prevAsset.page !== 'live' &&
        nextAsset.page !== 'live' &&
        !prevAsset.enableLiveAutoBuy &&
        !nextAsset.enableLiveAutoBuy &&
        id1 === id2 &&
        prevAsset.index === nextAsset.index &&
        item1 === item2 &&
        prevAsset.isSelected === nextAsset.isSelected &&
        item1 === 0 &&
        item2 === 0
    )
}

export default React.memo(MarketAssetPreview, assetPropsAreEqual)
